var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-terms-of-service.dc90ee82.png","uri@2x": __webpack_public_path__ + "icon-terms-of-service.58fa147d.png","uri@3x": __webpack_public_path__ + "icon-terms-of-service.e6247ea5.png",
    width: 20,
    height: 20
});